import React, { useState, useEffect } from 'react';

import { ICatalogSearch, ISearchInput } from 'src/pages/CatalogPage/CatalogPage.i';
import { Button, IconArrowLeft, IconArrowRight, Typography } from '@riac/design-system';
import { FiltersMobileMenu } from '../FilterMenu/FiltersMobileMenu/FiltersMobileMenu';
import { IAuctionMappings, TAuctionCollections } from '../../Catalog.i';

interface IPaginationBar {
  loc: 'top' | 'bottom';
  searchBusy: boolean;
  pageNumber: number;
  sortBy: string;
  perPage: number;
  updateSearch: ICatalogSearch;
  totalResults: number;
  auctionTypeId: number;
  facets: any;
  updateFilter: (slug: string, field: keyof IAuctionMappings) => void;
  mappings: IAuctionMappings;
  searchInput: ISearchInput;
  collections: TAuctionCollections;
  searchName: any;
}

export const PaginationBar = (props: IPaginationBar) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(true);

  const totalPages = Math.ceil(props.totalResults / props.perPage);

  function nextPage(): void {
    if(props.pageNumber + 1 <= totalPages) {
      props.updateSearch({
        pageNumber: props.pageNumber + 1,
      });
    }
  }

  function prevPage(): void {
    if(props.pageNumber - 1 > 0) {
      props.updateSearch({
        pageNumber: props.pageNumber - 1,
      });
    }
  }

  // Setup vars to show limits to user
  const pagesDropdown = [];
  for(let i = 1; i <= totalPages; i++) {
    pagesDropdown.push(i);
  }
  let sortByOptions = [
    { value: 'LotNumber,ASC', label: 'Lot # (ASC)' },
    { value: 'LotNumber,DESC', label: 'Lot # (DESC)' },
    { value: 'CurrentBid,ASC', label: 'Current Bid (ASC)' },
    { value: 'CurrentBid,DESC', label: 'Current Bid (DESC)' },
    { value: 'LowEst,ASC', label: 'Est. Low Price (ASC)' },
    { value: 'LowEst,DESC', label: 'Est. Low Price (DESC)' },
    { value: 'HighEst,ASC', label: 'Est. High Price (ASC)' },
    { value: 'HighEst,DESC', label: 'Est. High Price (DESC)' },
    { value: 'ManufacturerName,ASC', label: 'Manufacturer (ASC)' },
    { value: 'ManufacturerName,DESC', label: 'Manufacturer (DESC)' },
    { value: 'ModelDescription,ASC', label: 'Model (ASC)' },
    { value: 'ModelDescription,DESC', label: 'Model (DESC)' },
    { value: 'ItemInterest,ASC', label: 'Activity (ASC)' },
    { value: 'ItemInterest,DESC', label: 'Activity (DESC)' },
  ];

  // Remove estimated price sort options for timed auctions
  if(props.auctionTypeId === TIMED_AUCTION_TYPE_ID) {
    sortByOptions = sortByOptions.filter((x) => !x.label.includes('Est. '));
  } else {
    sortByOptions = sortByOptions.filter((x) => !x.label.includes('Bid '));
    sortByOptions = sortByOptions.filter((x) => !x.label.includes('Activity '));
  }

  useEffect(() => {
    let timer1;
    if(isOpen) {
      timer1 = setTimeout(() => setIsAnimating(false), 500);
    } else {
      setIsAnimating(true);
    }
    return () => clearTimeout(timer1);
  }, [isOpen]);

  return (
    <div className='flex flex-row justify-between w-full flex-1'>
      <div>
        <div className=''>
          {props.loc !== 'bottom' && <FiltersMobileMenu
            facets={props.facets}
            updateFilter={props.updateFilter}
            mappings={props.mappings}
            searchInput={props.searchInput}
            collections={props.collections}
            searchBusy={props.searchBusy}
            searchName={props.searchName}
          />}
        </div>
      </div>
      <div className='flex flex-row gap-5 items-center'>
        <Typography size='sm' weight='medium' color='text'>Page {props.pageNumber} of {totalPages}</Typography>
        <Button variant='secondary' className='w-9 h-9 p-0 flex items-center justify-center' isDisabled={props.searchBusy || props.pageNumber == 1} onPress={prevPage}>
          <IconArrowLeft/>
        </Button>
        <Button variant='secondary' className='w-9 h-9 p-0 flex items-center justify-center ' isDisabled={totalPages === 0 || props.searchBusy || props.pageNumber === totalPages} onPress={nextPage}>
          <IconArrowRight/>
        </Button>
      </div>
    </div>
  );
};
